import { createIcon } from './utils';

const AlertFill = createIcon(
  'AlertFill',
  'M12.7405 3.9324L20.8854 18.2027C20.9605 18.3342 21 18.4833 21 18.6351C21 18.7869 20.9605 18.9361 20.8855 19.0676C20.8104 19.199 20.7025 19.3082 20.5725 19.3841C20.4425 19.46 20.2951 19.5 20.145 19.5H3.85501C3.70492 19.5 3.55748 19.46 3.4275 19.3841C3.29752 19.3082 3.18959 19.199 3.11455 19.0676C3.0395 18.9361 3 18.7869 3 18.6351C3 18.4833 3.03951 18.3342 3.11455 18.2027L11.2595 3.9324C11.3346 3.80093 11.4425 3.69176 11.5725 3.61586C11.7025 3.53996 11.8499 3.5 12 3.5C12.1501 3.5 12.2975 3.53996 12.4275 3.61586C12.5575 3.69176 12.6654 3.80093 12.7405 3.9324ZM11.145 15.1757V16.9054H12.855V15.1757H11.145ZM11.145 9.1216V13.4459H12.855V9.1216H11.145Z'
);

export default AlertFill;
